
export interface ApproverDefinitionItem {
    roleNumber?: EnumApproverType;
    groupId?: number;
    groupName?: string;
}

export interface DefinitionsStyle {
    readonly name: string;
    readonly mainColor: string;
    readonly secondaryColor: string;
    readonly backColor: string;
    readonly logo?: string;
    readonly coverName?: string;
    readonly coverImage?: string;
    readonly apiExposureEnabled?: boolean;
    readonly isUnauthorized?: boolean;
    readonly isApprovalRequired?: boolean;
    readonly approvers?: ApproverDefinitionItem[]
    readonly isNotificationEnabled?: boolean;
    readonly notificationEmail?: string;
}
  export enum EnumApproverType
  {
      FirstManager = 1,
      SecondManager = 2
  }